import { render, staticRenderFns } from "./AboutSundairBox.vue?vue&type=template&id=733cd8bf&scoped=true"
import script from "./AboutSundairBox.vue?vue&type=script&lang=js"
export * from "./AboutSundairBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733cd8bf",
  null
  
)

export default component.exports